  
  function changeImage(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
  
    var allImages = document.querySelectorAll('[data-alt-color]');
    allImages.forEach(function(image) {
      image.classList.add('thumb-hidden-pdp');
    });
  
    var imagesToShow = document.querySelectorAll(`[alt*="${productColor}"]`);
    imagesToShow.forEach(function(image) {
      image.classList.remove('thumb-hidden-pdp');
    });
  };
  
  
  function changeImagePLP(clickedSwatch) {
    var galleryCard = clickedSwatch.closest('.product-item');
    if (galleryCard?.bhPreviewColor) { galleryCard.bhPreviewColor(clickedSwatch.getAttribute('data-option-value').replace(/-\d+$/, '')); return; }
    var productColor = clickedSwatch.getAttribute('data-option-value');
    var productId = clickedSwatch.getAttribute('data-product-id');
    var image = document.querySelector(`[data-thumbnail-color="${productColor}"]`);
    var image_two = document.querySelector(`[data-mi-atributo="${productId}"]`);

    if( image ) {
      if ( image.alt === productColor ) {
          image.classList.remove('thumb-hidden');
          if(image_two){
            if( image_two.id === productId ){
                image_two.classList.add('thumb-hidden');
             
            }
          }
      }
    }
  };


  function outImage(clickedSwatch) {
    var galleryCard = clickedSwatch.closest('.product-item');
    if (galleryCard?.bhRestoreColor) { galleryCard.bhRestoreColor(); return; }
    var productColor = clickedSwatch.getAttribute('data-option-value');
    var productId = clickedSwatch.getAttribute('data-product-id');
    var image = document.querySelector(`[data-thumbnail-color="${productColor}"]`);
    var image_two = document.querySelector(`[data-mi-atributo="${productId}"]`);


    if( image ) {
      if ( image.alt === productColor ) {
          image.classList.add('thumb-hidden');
          if(image_two){
            if( image_two.id === productId ){
                image_two.classList.remove('thumb-hidden');
             
            }
          }
      }
    }
  };
/* Draft product-card galleries: images arrive in Liquid, without a network lookup. */
(() => {
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  function initialize(root=document) {
    root.querySelectorAll('[data-card-gallery]').forEach(script => {
      if(script.dataset.ready) return;
      script.dataset.ready='true';
      let data;try { data=JSON.parse(script.textContent); } catch { return; }
      const media=script.closest('.product-item__media'),card=media.closest('.product-item');
      const link=media.querySelector('.product-item__image-link'),img=link?.querySelector('img[data-mi-atributo], img.image__img') || link?.querySelector('img');
      const previous=media.querySelector('.bh-gallery-prev'),next=media.querySelector('.bh-gallery-next');
      if(!img || !previous || !next) return;
      media.classList.add('bh-card-gallery');
      let images=[],index=0,start=null,swiped=false,revealOnly=false;
      const source=value=>String(value || '').split('?')[0].replace(/^https?:/,'');
      function selectColor(color,featured=data.featured) {
        const matching=data.images.filter(image=>{
          const alt=normalize(image.altText);
          return alt && data.colors.filter(value=>(' '+alt+' ').includes(' '+normalize(value)+' ')).sort((a,b)=>b.length-a.length)[0]===color;
        });
        images=matching;
        if(!images.length && data.colors.length<=1) images=data.images;
        if(!images.length) {
          const begin=data.images.findIndex(image=>source(image.url)===source(featured));
          const colorIndex=data.options.findIndex(option=>/^(color|colour)$/i.test(option));
          const boundaries=new Set(data.variants.filter(v=>v.options[colorIndex]!==color).map(v=>String(v.imageId)));
          const end=data.images.findIndex((image,i)=>i>begin && boundaries.has(String(image.id)));
          images=begin<0?[]:data.images.slice(begin,end<0?data.images.length:end);
        }
        const first=data.images.find(image=>source(image.url)===source(featured));
        images=[first,...images].filter(Boolean).filter((image,i,all)=>all.findIndex(other=>source(other.url)===source(image.url))===i);
        index=0;previous.hidden=next.hidden=images.length<2;
      }
      let selectedColor=data.color;
      selectColor(selectedColor);
      let previewing=false,savedIndex=0;
      const swatchColor=swatch=>swatch.dataset.cardColor || swatch.getAttribute('data-option-value')?.replace(/-\d+$/,'');
      function preview(color) {
        if(!data.colors.includes(color))return;
        const colorIndex=data.options.findIndex(option=>/^(color|colour)$/i.test(option));
        const variant=data.variants.find(v=>v.options[colorIndex]===color && v.imageId);
        const matching=data.images.find(image=>String(image.id)===String(variant?.imageId)) || data.images.find(image=>normalize(image.altText)===normalize(color));
        img.classList.remove('thumb-hidden');
        link.querySelectorAll('img[data-thumbnail-color]').forEach(image=>image.classList.add('thumb-hidden'));
        selectColor(color,matching?.url);show(0);
      }
      card.bhPreviewColor=preview;
      card.bhRestoreColor=()=>{preview(selectedColor);index=Math.min(savedIndex,Math.max(0,images.length-1));show(0);previewing=false;};
      card.querySelectorAll('[data-card-color],[data-option-value]').forEach(swatch=>{
        const color=swatchColor(swatch);
        if(!data.colors.includes(color))return;
        swatch.addEventListener('pointerenter',event=>{if(event.pointerType==='touch')return;if(!previewing)savedIndex=index;previewing=true;preview(color);});
        swatch.addEventListener('pointerleave',()=>{if(previewing)card.bhRestoreColor();});
      });
      media.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'){revealOnly=!media.classList.contains('bh-gallery-touched') && images.length>1;media.classList.add('bh-gallery-touched');}},{capture:true});
      document.addEventListener('pointerdown',event=>{if(!media.contains(event.target))media.classList.remove('bh-gallery-touched');});
      media.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')media.classList.remove('bh-gallery-touched');});
      card.querySelectorAll('[data-card-color]').forEach(swatch=>swatch.setAttribute('aria-pressed',String(swatch.dataset.cardColor===selectedColor)));
      function show(change) {
        if(!images.length) return;
        index=(index+change+images.length)%images.length;
        const url=new URL(images[index].url,location.origin);url.searchParams.set('width','900');
        img.removeAttribute('srcset');img.src=url.href;img.alt=images[index].altText || data.title;
      }
      [previous,next].forEach((button,i)=>button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();show(i?1:-1);}));
      link.draggable=false;img.draggable=false;link.style.touchAction='pan-y';
      link.addEventListener('pointerdown',event=>{event.stopPropagation();start={x:event.clientX,y:event.clientY};swiped=false;link.setPointerCapture(event.pointerId);});
      link.addEventListener('pointermove',event=>{if(start)event.stopPropagation();});
      link.addEventListener('pointerup',event=>{
        if(!start)return;event.stopPropagation();
        const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;
        if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.2){swiped=true;show(dx<0?1:-1);}
      });
      link.addEventListener('pointercancel',()=>{start=null;});
      link.addEventListener('click',event=>{if(swiped || revealOnly){event.preventDefault();event.stopPropagation();swiped=false;revealOnly=false;}},true);
      card.addEventListener('click',event=>{
        const swatch=event.target.closest('[data-card-color],[data-option-value]');
        if(!swatch)return;
        const color=swatchColor(swatch);
        if(!data.colors.includes(color))return;
        event.preventDefault();event.stopPropagation();selectedColor=color;previewing=false;savedIndex=0;preview(color);
        card.querySelectorAll('[data-card-color],[data-option-value]').forEach(button=>{const selected=swatchColor(button)===color;button.classList.toggle('selected',selected);button.setAttribute('aria-pressed',String(selected));});
      },true);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
